// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fT5K","title":"styles_title__3d3nV"};